module.exports.NumberFormat = { 
    UNS: 0, 
    FDI: 1
};

module.exports.VisibilityType = { 
    SOLID: 1, 
    WIREFRAME: 2, 
    NONE: 0,
    INSIDE: 3,
    OUTSIDE:4
 };

module.exports.FocusJaw = { 
    GLOBAL: 0, 
    UPPER: 1, 
    LOWER: 2
};

module.exports.FdiNumbers = [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28, 38, 37, 36, 35, 34, 33, 32, 31, 41, 42, 43, 44, 45, 46, 47, 48];

